"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
const react_1 = __importStar(require("react"));
const constants_1 = require("./helpers/constants");
const Slider_styles_1 = require("./Slider.styles");
const helpers_1 = require("../../helpers");
const mathSign_1 = require("../../helpers/mathSign");
const Text_1 = require("../../Text");
const helpers_2 = require("./helpers/helpers");
exports.Slider = (0, helpers_1.createUIElement)('Slider', (_a, ref) => {
    var { className, value: valueProp = 0, disabled = false, min = 0, max = 100, hasLabels = false, texts, step = 5, onChange, renderTooltip, onFocus, onBlur, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "value", "disabled", "min", "max", "hasLabels", "texts", "step", "onChange", "renderTooltip", "onFocus", "onBlur", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    let value = valueProp;
    (0, helpers_2.checkSliderMinMaxProps)({ min, max });
    (0, helpers_2.checkSliderStepProperty)({ min, max, step });
    value = (0, helpers_2.getLimitedValue)({ min, value, max });
    const uiTexts = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, constants_1.SLIDER_DEFAULT_LABEL_TEXTS), texts)), [texts]);
    const trackRef = (0, react_1.useRef)(null);
    const thumbRef = (0, react_1.useRef)(null);
    const tooltipRef = (0, react_1.useRef)(null);
    const tooltipValueRef = (0, react_1.useRef)(value);
    const removeListenerRef = (0, react_1.useRef)(null);
    const [tooltipValue, setTooltipValue] = (0, react_1.useState)(null);
    const [changeValueProcess, setChangeValueProcess] = (0, react_1.useState)(false);
    if (tooltipValueRef.current !== value) {
        tooltipValueRef.current = value;
    }
    (0, react_1.useEffect)(() => {
        return () => {
            if (removeListenerRef.current) {
                removeListenerRef.current();
            }
        };
    }, []);
    const thumbMouseDownHandler = (0, react_1.useCallback)((e) => {
        if (trackRef.current === null || removeListenerRef.current) {
            return;
        }
        const startClientX = e.clientX;
        const trackWidth = trackRef.current.clientWidth;
        let newValue = value;
        const mouseMoveHandler = (event) => {
            if (disabled) {
                return;
            }
            const clientXDelta = event.clientX - startClientX;
            const direction = (0, mathSign_1.mathSign)(clientXDelta);
            const newPosition = (0, helpers_2.getNewPositionThumb)(value, trackWidth, clientXDelta, max, min);
            newValue = (0, helpers_2.getValueFromPositionThumb)(value, newPosition, step, direction);
            if (tooltipValue !== newValue) {
                setTooltipValue(newValue);
            }
            if (thumbRef.current) {
                thumbRef.current.style.left = `calc(${newPosition}% - 8px - ${Slider_styles_1.thumbConfig.padding})`;
            }
            if (tooltipRef.current) {
                tooltipRef.current.style.left = `calc(${newPosition}% - ${newPosition}px)`;
            }
            setChangeValueProcess(true);
        };
        const mouseHandler = () => {
            onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
            if (thumbRef.current) {
                thumbRef.current.style.left = '';
            }
            if (tooltipRef.current) {
                tooltipRef.current.style.left = '';
                setTooltipValue(null);
            }
            if (removeListenerRef.current) {
                removeListenerRef.current();
                removeListenerRef.current = null;
            }
            setChangeValueProcess(false);
        };
        window.document.addEventListener('mousemove', mouseMoveHandler);
        window.document.addEventListener('mouseleave', mouseHandler);
        window.document.addEventListener('mouseup', mouseHandler);
        removeListenerRef.current = () => {
            window.document.removeEventListener('mousemove', mouseMoveHandler);
            window.document.removeEventListener('mouseleave', mouseHandler);
            window.document.removeEventListener('mouseup', mouseHandler);
        };
    }, [disabled, max, min, onChange, step, tooltipValue, value]);
    const trackMouseUpHandler = (0, react_1.useCallback)((e) => {
        var _a;
        if (changeValueProcess || disabled) {
            return;
        }
        const trackRect = (_a = trackRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const trackWidth = trackRect === null || trackRect === void 0 ? void 0 : trackRect.width;
        const trackLeft = trackRect === null || trackRect === void 0 ? void 0 : trackRect.left;
        const clientX = e === null || e === void 0 ? void 0 : e.nativeEvent.pageX;
        if (clientX !== undefined && trackLeft !== undefined && trackWidth !== undefined) {
            const percentPosition = ((clientX - trackLeft) * 100) / trackWidth;
            const filteredPercentPositionByMinMax = Math.max(Math.min(percentPosition, max), min);
            const numberHiddenPoint = filteredPercentPositionByMinMax / step;
            const nearestNumberPhysicalHiddenPoint = numberHiddenPoint < Math.trunc(numberHiddenPoint) + 0.5
                ? Math.trunc(numberHiddenPoint)
                : Math.trunc(numberHiddenPoint) + 1;
            onChange === null || onChange === void 0 ? void 0 : onChange(nearestNumberPhysicalHiddenPoint * step);
        }
    }, [changeValueProcess, disabled, max, min, onChange, step]);
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'slider-wrapper', [initialDataSelectorId]);
    const hasTooltip = (0, react_1.useMemo)(() => renderTooltip !== null, [renderTooltip]);
    const sliderTooltipValue = tooltipValue !== null ? tooltipValue : tooltipValueRef.current;
    const view = (0, react_1.useMemo)(() => (disabled ? Text_1.TEXT_VIEW.light : Text_1.TEXT_VIEW.primary), [disabled]);
    return (react_1.default.createElement(Slider_styles_1.StyledSlider, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, hasStepLabels: hasLabels, hasTooltip: hasTooltip, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-Slider', className) }),
        react_1.default.createElement(Slider_styles_1.StyledSliderTrack, { ref: trackRef, disabled: disabled, onMouseUp: trackMouseUpHandler, hasTooltip: hasTooltip },
            [min, max].map((leftValue) => (react_1.default.createElement(Slider_styles_1.StyledSliderPoint, { key: leftValue, leftValue: leftValue, disabled: disabled, interactiveMode: !changeValueProcess, onClick: () => {
                    if (!disabled) {
                        onChange === null || onChange === void 0 ? void 0 : onChange(leftValue);
                    }
                } }))),
            react_1.default.createElement(Slider_styles_1.StyledSliderThumb, { "data-selector-id": "slider-thumb", ref: thumbRef, onMouseDown: thumbMouseDownHandler, position: value, disabled: disabled },
                react_1.default.createElement(Slider_styles_1.StyledSliderFillCircleThumb, { "data-track-fill-circle-thumb": true })),
            hasTooltip && (react_1.default.createElement(Slider_styles_1.StyledSliderTooltip, { ref: tooltipRef, position: value, disabled: disabled, hasTooltip: true, "data-track-tooltip": true }, renderTooltip ? (renderTooltip({
                value: sliderTooltipValue,
                min,
                max,
                disabled,
                step
            })) : (react_1.default.createElement(Slider_styles_1.StyledSliderTooltipText, { align: Text_1.TEXT_ALIGN.center, disabled: disabled, view: view, truncate: true }, sliderTooltipValue)))),
            hasLabels && (react_1.default.createElement(Slider_styles_1.StyledSliderStepLabel, { value: min, size: Text_1.TEXT_SIZE.s, view: view }, uiTexts.minValueLabel)),
            hasLabels && (react_1.default.createElement(Slider_styles_1.StyledSliderStepLabel, { isSecond: true, value: max, size: Text_1.TEXT_SIZE.s, view: view }, uiTexts.maxValueLabel)))));
});
//# sourceMappingURL=Slider.js.map